<template>
    <div class="partner-container">
        <div class="partner-container--top">
            <filter-form class="filter-form"></filter-form>
            <map-box></map-box>
        </div>
        <partner-list></partner-list>
        <survey-box></survey-box>
    </div>
</template>

<script>
import FilterForm from "./FilterForm";
import PartnerList from "./PartnerList";
import SurveyBox from "./SurveyBox";
import MapBox from "./MapBox";

export default {
    components: {
        MapBox,
        SurveyBox,
        PartnerList,
        FilterForm
    },
}
</script>

<style lang="scss">
    @import "../../../sass/partner/main";
</style>
